<template>
  <div class="form-radio-input form-item">
    <div class="form-item-content">
      <x-proxy-form-item
        :showRequired="showRequired"
        :label="widget.label"
        :processTitle="widget.processTitle"
        :validatorRules="validatorRules"
        :validateKey="validateKey"
        :validateInfo="validateInfo"
        :disabled="widget.readOnly"
      >
        <cube-radio-group v-if="renderSence === 'edit'">
          <cube-radio
            v-for="(option, index) in chooseOptions"
            class="form-radio-choose"
            :key="index"
            :option="option"
            v-model="formValueData"
            @click.native.prevent="getRadioStatus(option)"
          >
            <div class="radio-box">
              <x-svg-icon
                v-if="formValueData === option.value"
                class="radio-svg-ui active"
                :class="widget.readOnly ? 'disable' : ''"
                name="x-lib-radio-active"
              ></x-svg-icon>
              <x-svg-icon v-else class="radio-svg-ui" name="x-lib-radio"></x-svg-icon>
              <div
                class="radio-tag"
                :style="{ 'background-color': widget.multicolor ? option.color : widget.readOnly ? '' : '#FFFFFF', 'color': widget.multicolor ? '#FFFFFF' : widget.readOnly ? '#B2B2B2' : '#303133', 'margin': widget.multicolor ? '' : 0 }"
              >
                <span>{{option.label}}</span>
              </div>
            </div>
          </cube-radio>
        </cube-radio-group>
        <div class="radio-read-tag-box" v-if="renderSence === 'read'">
          <div
            :style="{ 'background-color': widget.multicolor ? tag.color : '#fafafa', 'color': widget.multicolor ? '#FFFFFF' : widget.readOnly ? '#B2B2B2' : '#303133' }"
            class="radio-read-tag"
            v-for="tag in formValueShowList"
            :key="tag.id"
          >{{ tag.label }}</div>
        </div>
      </x-proxy-form-item>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'

export default {
  name: 'FormValueRadio',
  mixins: [FormWidgetConfigMixin],
  computed: {
    chooseOptions() {
      return this.widget.chooseOptions.filter((item) => item.label && item.status === 'ENABLE').map((item) => {
        return {
          label: item.label,
          value: item.id,
          color: item.color
        }
      })
    },
    formValueData: {
      get() {
        if (this.formValue instanceof Array) {
          if (this.formValue.length > 0) {
            return this.formValue[0]
          } else {
            return ''
          }
        } else {
          return this.formValue || ''
        }
      },
      set(value) {
        if (value) {
          this.formValue = [value]
        } else {
          this.formValue = []
        }
      }
    },
    formValueShowList: function() {
      let arr = []
      if (this.formValue && this.formValue.length > 0) {
        if (this.widget.chooseType === 'MULTI') {
          this.widget.chooseOptions.forEach((item) => {
            this.formValue.forEach((id) => {
              if (id === item.id) {
                arr.push(item)
              }
            })
          })
        } else {
          if (typeof this.formValue === 'string') {
            arr = this.widget.chooseOptions.filter((item) => item.id === this.formValue)
          } else {
            this.widget.chooseOptions.forEach((item) => {
              this.formValue.forEach((id) => {
                if (id === item.id) {
                  arr.push(item)
                }
              })
            })
          }
        }
      }
      return arr
    }
  },
  created() {
  },
  methods: {
    getRadioStatus(data) {
      if (this.widget.readOnly) {
        return
      }
      data.value === this.formValueData
        ? (this.formValueData = '')
        : (this.formValueData = data.value)
    }
  }
}
</script>

<style lang="scss">
.border-bottom-1px::after {
  border-bottom: 1PX solid $--app-info-color;
}
.form-radio-input {
  .form-item-content {
    z-index: 1;
    position: relative;
    .border-top-1px::before {
      border: 0 !important;
    }
    .border-bottom-1px::after {
      border: 0;
    }
    .disable {
      color: $--app-notice-color !important;
    }
    .form-radio-choose {
      padding-right: 0 !important;
      // padding-left: 2.286rem !important;
      padding-left: 0;
      position: relative;
      min-height: 2.857rem;

      .cube-radio-wrap {
        padding: .392857rem 0;
      }

      .cube-radio-ui {
        opacity: 0;
        display: none;
      }

      .radio-box {
        display: flex;
        min-height: 2.857rem;
        align-items: center;
        // position: absolute;
        // left: -2.286rem;
        // top: 0;
        // width: calc(100% - 1.571rem);
        .radio-svg-ui {
          display: flex;
          align-items: center;
          color: $--app-notice-color;
          margin-left: -0.214rem;
          &.active {
            color: $--app-primary-color;
          }
        }
        .radio-tag {
          min-height: 1.714rem;
          display: flex;
          align-items: center;
          padding: .392857rem .786rem;
          margin-left: 0.715rem;
          border-radius: .857rem;
          max-width: 95%;

          span {
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            width: 100%;
            line-height: 1.5;
            display: inline-block;
          }
        }
      }
    }
    .radio-read-tag-box {
      display: flex;
      flex-wrap: wrap;
      .radio-read-tag {
        min-height: 1.714rem;
        display: flex;
        align-items: center;
        padding: .392857rem .786rem;
        border-radius: .857rem;
        max-width: 100%;
        line-height: 1.5;
      }
    }
  }
  .readonly-background {
    background-color: $--app-form-readonly-bgColor !important;

    .cube-radio-group {
      background-color: $--app-form-readonly-bgColor !important;
    }
  }
}
</style>